"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactive_google_map_1 = require("@dotdev/reactive-google-map");
var __1 = require("../");
var StoreLocatorSearch = /** @class */ (function (_super) {
    __extends(StoreLocatorSearch, _super);
    function StoreLocatorSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: "",
        };
        _this.handleSelect = function (place) { return __awaiter(_this, void 0, void 0, function () {
            var position;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.autocomplete) {
                            return [2 /*return*/];
                        }
                        position = {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                        };
                        if (this.props.onSelect) {
                            this.props.onSelect(place);
                        }
                        if (!this.context.storeLocator.googleMapClient) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.context.storeLocator.googleMapClient.mapPanTo(position)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.context.storeLocator.updateQuery({
                                position: position,
                                bounds: reactive_google_map_1.Bounds.simplifyBounds(place.geometry.viewport),
                                source: "search",
                            })];
                    case 2:
                        _a.sent();
                        this.context.storeLocator.googleMapClient.mapFitMarkers();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleChange = function (event) {
            if (_this.props.autocomplete) {
                return;
            }
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
            _this.setState({
                value: event.target.value,
            });
            _this.context.storeLocator.updateQuery({
                search: event.target.value,
                source: "search",
            });
        };
        _this.renderAutocompleteInput = function (props) { return (React.createElement(reactive_google_map_1.GoogleMapAutocomplete, __assign({ googleMapsApiVersion: _this.context.storeLocator.options.googleMapsApiVersion, googleMapsApiKey: _this.context.storeLocator.options.googleMapsApiKey, callback: _this.context.storeLocator.setGoogleMapAutocompleteClient, onSelect: _this.handleSelect }, props))); };
        _this.renderTextInput = function (props) { return (React.createElement("input", { style: props.style, className: props.className, placeholder: props.placeholder, value: _this.state.value, onChange: _this.handleChange })); };
        return _this;
    }
    StoreLocatorSearch.prototype.render = function () {
        if (this.props.autocomplete) {
            return this.renderAutocompleteInput(this.props);
        }
        return this.renderTextInput(this.props);
    };
    StoreLocatorSearch.contextType = __1.Context;
    return StoreLocatorSearch;
}(React.Component));
exports.StoreLocatorSearch = StoreLocatorSearch;
//# sourceMappingURL=store-locator-search.js.map